/**
The routing of this file will not show the layout.
It is an independent new page.
the contents of the file still need to log in to access
 */
import type { AppRouteModule } from '/@/router/types';

// 数据看板(/admin/dashboard)、用户管理(/admin/users)与创建标注项目
// (/admin/projects/new)已分别于 2026-08-27 改挂全局 annotate LAYOUT
// (router/routes/modules/admin.ts),不再在此注册整屏路由;老板反馈 3/4:
// 整屏页自带内嵌侧栏与全局侧栏不一致,现统一走全局外壳。
// 数据审核(/admin/review/:dataId)同日改挂 admin.ts LAYOUT children,
// URL 形态不变。

// Annotation Workspace visual preview — UI shell only. The pc-tool /
// image-tool engines are NOT mounted; the canvas region shows a
// placeholder explaining where the real renderer would go. Use this
// page to preview the new design language before deciding whether to
// graft it onto the actual annotation editors (see conflict analysis).
const adminWorkspacePreviewRoute: AppRouteModule = {
  path: '/admin/workspace-preview',
  name: 'AdminWorkspacePreview',
  component: () => import('/@/views/admin/workspacePreview/index.vue'),
  meta: {
    title: '标注工作台 · 预览',
    permission: 'data:annotate',
  },
};

// Training Module — full-viewport dark "course player" combining a
// scripted lesson video, slide deck, and per-question quiz. Open to all
// logged-in users (no permission gate); annotators land here to skill
// up before being moved off probation.
const trainingRoute: AppRouteModule = {
  path: '/training',
  name: 'Training',
  component: () => import('/@/views/training/index.vue'),
  meta: {
    title: '培训中心',
  },
};

// Crowd Marketplace — annotator-facing list of "open" datasets they
// can claim batches from. Cards show reward, difficulty, deadline,
// claim progress; clicking claim runs the same takeRecordByData flow
// as the dataset page so the annotator drops into pc-tool / image-tool
// directly.
const marketplaceRoute: AppRouteModule = {
  path: '/marketplace',
  name: 'Marketplace',
  component: () => import('/@/views/marketplace/index.vue'),
  meta: {
    title: '众包市场',
  },
};

// Admin · 用户管理(/admin/users)已改挂 LAYOUT,见文件头注释。

// test
// http:ip:port/main-out
// 众包/培训残留页下线(老板 2026-09-05 审计:两页为 mock 假数据,入口虽已
// 隐藏但 URL 仍可直达,从路由表整体移除;Phase 2 重启时再恢复)
export const mainOutRoutes: AppRouteModule[] = [
  adminWorkspacePreviewRoute,
  // trainingRoute,
  // marketplaceRoute,
];

export const mainOutRouteNames = mainOutRoutes.map((item) => item.name);
